export const initialState = (inputResponse: any, isEdit = false) => {
  return {
    developerId: { value: inputResponse?.developer_name ?? '', id: inputResponse.developerId ?? '', error: '' },
    projectId: { value: inputResponse?.project_name ?? '', id: inputResponse.projectId ?? '', error: '' },
    unitConfig: { value: inputResponse?.unitConfig ?? [], id: inputResponse.unitConfigId ?? '', error: '' },
    form_name: { value: inputResponse.form_name ?? '', error: '' },
    leadName: { value: inputResponse.leadName ?? '', error: '' },
    leadEmail: { value: inputResponse.leadEmail ?? '', error: '' },
    leadPhone: { value: inputResponse.leadPhone ?? '', error: '' },
    phoneCountryCode: { value: inputResponse.phoneCountryCode ?? '', error: '' },
    id: { value: inputResponse._id ?? inputResponse.id ?? '', error: '' },
  };
};

export const handleValidation = (
  rawInput: any,
  _opts?: { skipProject?: boolean; skipDeveloper?: boolean }
) => {
  // Developer Name and Project Name are optional
  if (rawInput.developerId) rawInput.developerId.error = "";
  if (rawInput.projectId) rawInput.projectId.error = "";

  if (rawInput.form_name.value === '') {
    rawInput.form_name.error = 'Please enter form name';
  }

  return rawInput;
};

export const validateInput = (name: any, value: any) => {

  if (name === 'zipcode') {
    if (!/^[0-9]+$/.test(value) || value.length > 6) {
      return false;
    }
  }

  if (name === 'description') {
    if (!/^[a-zA-Z0-9\s.,-]+$/.test(value) && value !== '') {
      return false;
    }
  }

  return true;
};

export const getFinalBodyStructure = (inputBody: any) => {
  let finalBody: any = {};
  for (const key in inputBody) {
    if (key === "dynamicFields") continue;
    if (["developerId", "projectId", "projecttypeId"].includes(key)) {
      finalBody[key] = inputBody[key]?.id ?? "";
      continue;
    }
    if (key === "unitConfig") {
      const raw = inputBody[key]?.value;
      finalBody.unitConfig = Array.isArray(raw)
        ? raw.map((item: any) =>
            typeof item === "object" && item != null
              ? { id: item.id, label: item.label, bedroom: item.bedroom, sqft: item.sqft }
              : item
          )
        : [];
      continue;
    }
    finalBody[key] = inputBody[key]?.value ?? "";
  }
  // Keep form id for updateForm
  if (!finalBody.id && inputBody?.id?.value) {
    finalBody.id = inputBody.id.value;
  }
  // Persist field config without webpack icon URLs (restored on edit by type)
  finalBody.dynamicFields = (Array.isArray(inputBody.dynamicFields)
    ? inputBody.dynamicFields
    : []
  ).map((item: any) => {
    if (!item || typeof item !== "object") return item;
    const { icon, ...rest } = item;
    return rest;
  });
  return finalBody;
};
